import React from 'react';
import GradeBadge from '../components/GradeBadge';

const GRADE_EXPLAINERS = [
    {
        grade: 1,
        label: 'Speculative',
        text: "We see a pattern but we can't fully prove it yet. This is thinking out loud — following a thread to see where it leads. Read it as a question, not a conclusion. We publish it because the pattern deserves to be named even if the picture isn't complete.",
    },
    {
        grade: 2,
        label: 'Emerging',
        text: "There is something real here and we can point to it, but the full picture is still forming. Evidence exists but it's partial, or sits alongside credible counter-readings. Worth your attention. Not yet worth betting on.",
    },
    {
        grade: 3,
        label: 'Sourced',
        text: "The claims in this piece can be traced. We are drawing on things that are documented, on the record, or demonstrably true. We're not embellishing. We're reporting what we found and connecting it as honestly as we can.",
    },
    {
        grade: 4,
        label: 'Reframed',
        text: "The facts themselves are solid — but we are reading them through a different lens than the mainstream account. The events happened. The documents are real. What we're offering is a different interpretation of what they mean, usually through an Orthodox theological or historical frame that the secular world ignores.",
    },
    {
        grade: 5,
        label: 'Established',
        text: 'This is as close to certain as we get. Multiple independent lines of evidence point to the same conclusion. The pattern is not only visible — it has been named, documented, and confirmed from different directions. We stand behind it fully.',
    },
];

function GradingPage() {
    return (
        <article className="single-article">
            <header className="article-header">
                <div className="article-header-meta">
                    <span className="eyebrow">Methodology</span>
                </div>
                <h1 className="article-title">The Grading System</h1>
                <div className="article-info-bar">
                    <span className="small-meta">How we assess what we publish</span>
                </div>
            </header>

            <div className="article-content">
                <p>
                    Every piece carries a grade that tells you how much weight to put on what
                    you're reading. We are not academics. We are laymen trying to see clearly.
                    The grade reflects our honest assessment of how solid the ground is
                    beneath the argument.
                </p>

                <div className="grade-explainer-grid">
                    {GRADE_EXPLAINERS.map((entry) => (
                        <div className="grade-explainer-row" key={entry.grade}>
                            <div className="grade-explainer-badge">
                                <GradeBadge rating={entry.grade} withTitle={false} />
                            </div>
                            <div className="grade-explainer-text">
                                <div className="grade-explainer-label">{entry.label}</div>
                                <p>{entry.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </article>
    );
}

export default GradingPage;
